import { useMemo } from 'react';
import clsx from 'clsx';

import { Icon, Progress } from '@atom/mui';
import colors from '@atom/styles/colors';
import { AssetBudget } from '@atom/types/inventory';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import classes from './sddotCreate.module.css';

const styles = {
  icon: {
    marginRight: '1rem',
  },
};

interface Props {
  budget: AssetBudget;
  quantity?: number;
  // TODO: [AM-16707]: Temp code until BE solution is built
  totalRemaining: number;
  totalRemainingLoading: boolean;
}

const QuantityAdjustmentSubtext = ({
  quantity,
  budget,
  // TODO: [AM-16707]: Temp code until BE solution is built
  totalRemaining,
  totalRemainingLoading,
}: Props) => {
  // const updatedQuantity = useMemo(() => {
  //   return Number(budget?.quantityOnHand) + Number(quantity);
  // }, [quantity, budget?.quantityOnHand]);

  const updatedQuantity = useMemo(() => {
    return Number(totalRemaining) + Number(quantity);
  }, [quantity, totalRemaining, totalRemainingLoading]);

  const quantityError = updatedQuantity < 0;

  const content = quantityError
    ? `New stock level: ${updatedQuantity} ${budget?.unit}. Stock level cannot be negative.`
    : `New stock level: ${updatedQuantity} ${budget?.unit}`;
  const icon = quantityError ? 'error_outline' : 'info_outline';
  const iconColor = quantityError ? colors.brand.red : colors.brand.blue;

  return isNilOrEmpty(quantity) ? (
    <div />
  ) : (
    <div
      className={clsx(classes.quantitySubtext, quantityError && classes.error)}
    >
      <Icon style={styles.icon} color={iconColor}>
        {icon}
      </Icon>
      {totalRemainingLoading ? <Progress size={10} /> : content}
    </div>
  );
};

export default QuantityAdjustmentSubtext;
